import { AssertionDescriptorUsageTypesEnum, EntityTypes } from '../../../utilities/Constants';
import {
    IAssertionDescriptorModel,
    IEntityAssertionModel,
} from '../../../interfaces/IAssertionDescriptor';
import {
    INoteCategoryModel,
    INoteCategoryTypeModel,
    INotesUICustomization,
} from '../../../interfaces/INote';

import EntityAssertionControl from '../../shared/EntityAssertionControl';

interface INoteEditorAdditionalFieldsByNoteCategoryProps {
    noteCategory: INoteCategoryModel;
    noteCategoryTypes: INoteCategoryTypeModel[];
    notesUICustomization: INotesUICustomization | undefined;
    onNoteCategoryAdditionalFieldChange: (items: IEntityAssertionModel[], key?: any) => void;
    forceNoteEditorInReadOnlyMode: boolean;
}

export function NoteEditorAdditionalFieldsByNoteCategory(
    props: INoteEditorAdditionalFieldsByNoteCategoryProps
) {
    const match = props.noteCategoryTypes?.find((x) => x.id == props.noteCategory.id);
    if (!match || !match.assertionDescriptors || match.assertionDescriptors.length == 0)
        return null;

    return (
        <div>
            {props.notesUICustomization?.hideCategories && (
                <div className="row mb-2">
                    <div className="col-sm-12">
                        <label className="text-gray">
                            Additional Fields for Category - {match.displayName!} *
                        </label>
                    </div>
                </div>
            )}
            {match.assertionDescriptors.map((assertionDescriptor: IAssertionDescriptorModel) => {
                let noteAssertion: IEntityAssertionModel = {
                    entityType: {
                        id: EntityTypes.Note,
                    },
                    assertionDescriptorGuid: assertionDescriptor.guid ?? '',
                };

                const noteAssertionMatch = props.noteCategory.assertions?.find(
                    (x) => x.assertionDescriptorGuid == assertionDescriptor.guid
                );

                if (noteAssertionMatch) {
                    noteAssertion = { ...noteAssertion, ...noteAssertionMatch };
                }

                return (
                    <div key={assertionDescriptor.guid} className="row mb-2">
                        <div className="col-sm-2">
                            <label className="text-gray">{assertionDescriptor.displayName!}*</label>
                        </div>
                        <div className="col-sm-6">
                            <EntityAssertionControl
                                assertionDescriptor={assertionDescriptor}
                                assertionDescriptorUsageType={
                                    AssertionDescriptorUsageTypesEnum.Note
                                }
                                entityAssertions={[noteAssertion]}
                                refreshChange={props.onNoteCategoryAdditionalFieldChange}
                                additionalIdentifierKey={props.noteCategory.id}
                                handleNarrativeFieldEdit={() => {
                                    console.log('Function not implemented');
                                }}
                                editMode={!props.forceNoteEditorInReadOnlyMode}
                            />
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
